export const listKeyWord = [
    {
      "value": "Ban Giám đốc",
      "label": "Là Ban Giám đốc công ty VIAGS"
    },
    {
      "value": "Công ty/ VIAGS",
      "label": "Công ty Trách nhiệm hữu hạn một thành viên mặt đất sân bay Việt Nam"
    },
    {
      "value": "Khách hàng",
      "label": "Là các cá nhân hoặc tổ chức sử dụng dịch vụ của VIAGS hoặc có quan hệ đối tác, hợp tác với VIAGS."
    },
    {
      "value": "Ngày làm việc",
      "label": "Là các ngày từ Thứ 2 đến Thứ 6, trừ những ngày nghỉ tuần và nghỉ lễ theo quy định của Nhà nước ( Lưu ý: định nghĩa này có thể bị thay đổi theo quy định của Công ty)."
    },
    {
      "value": "Phòng chức năng",
      "label": "Cơ quan được Tổng giám đốc giao nhiệm vụ quản lý một lĩnh vực hoạt động trong hệ thống quản lý an toàn, an ninh, chất lượng và môi trường VIAGS (VD: Phòng An toàn Chất lượng và An ninh, Phòng Kế hoạch đầu tư,...)"
    },
    {
      "value": "Hệ thống quản lý SQMS",
      "label": "Là tập hợp các hệ thống quản lý của VIAGS bao gồm hệ thống quản lý chất lượng, hệ thống quản lý an toàn, hệ thống quản lý an ninh, hệ thống quản lý môi trường, hệ thống quản lý nguồn lực, hệ thống nguồn vật lực, hệ thống quản lý trình khai thác, hệ thống quản lý công nghệ thông tin, hệ thống tiếp thị và bán sản phẩm, hệ thống quản lý đào tạo."
    },
    {
      "value": "Cơ quan",
      "label": "Các phòng chức năng/ trung tâm trực thuộc Công ty"
    },
    {
      "value": "Chi nhánh",
      "label": "Các Chi nhánh trực thuộc Công ty, thực hiện việc cung cấp dịch vụ của VIAGS tại các sân bay"
    },
    {
      "value": "Đơn vị",
      "label": "Các Phòng/Trung tâm trực thuộc Chi nhánh"
    },
    {
      "value": "A/C",
      "label": "Tàu bay"
    },
    {
      "value": "AHL",
      "label": "Hồ sơ hành lý thất lạc (hành lý thiếu)"
    },
    {
      "value": "APU",
      "label": "Động cơ phụ tàu bay"
    },
    {
      "value": "ATA",
      "label": "Giờ đáp thực tế"
    },
    {
      "value": "ATD",
      "label": "Giờ khởi hành (đi) thực tế"
    },
    {
      "value": "AVI/AVIH",
      "label": "Động vật sống"
    },
    {
      "value": "AWB",
      "label": "Vận đơn hàng không"
    },
    {
      "value": "BAL",
      "label": "Bao dằn tải"
    },
    {
      "value": "BLND",
      "label": "Khách khiếm thị"
    },
    {
      "value": "BSCT",
      "label": "Dịch vụ nôi trẻ em trên tàu bay"
    },
    {
      "value": "BULK",
      "label": "Chất xếp rời"
    },
    {
      "value": "CHD",
      "label": "Khách trẻ em"
    },
    {
      "value": "CIP",
      "label": "Khách hợp tác thương mại"
    },
    {
      "value": "COMAT",
      "label": "Hàng nội bộ"
    },
    {
      "value": "CREW",
      "label": "Tổ bay"
    },
    {
      "value": "DEAF",
      "label": "Khách khiếm thính"
    },
    {
      "value": "DEPO",
      "label": "Khách bị trục xuất, khách phạm tội"
    },
    {
      "value": "DGD",
      "label": "Tờ khai hàng nguy hiểm"
    },
    {
      "value": "DGR",
      "label": "Hàng hoá nguy hiểm"
    },
    {
      "value": "E-AWB",
      "label": "Vận đơn điện tử"
    },
    {
      "value": "EIC",
      "label": "Phụ tùng được chất xếp ở hầm hàng"
    },
    {
      "value": "ETA",
      "label": "Giờ dự định đến"
    },
    {
      "value": "ETD",
      "label": "Giờ dự định khởi hành"
    },
    {
      "value": "EXST",
      "label": "Khách sử dụng dịch vụ mua thêm ghế ngồi"
    },
    {
      "value": "FFM",
      "label": "Điện danh sách hàng hóa trên chuyến bay"
    },
    {
      "value": "FIM",
      "label": "Chứng từ chuyển đổi hành trình không tự nguyện"
    },
    {
      "value": "FOD",
      "label": "Vật ngoại lai"
    },
    {
      "value": "FQTV",
      "label": "Khách hàng thường xuyên"
    },
    {
      "value": "FSU",
      "label": "Điện văn cập nhật trạng thái lô hàng"
    },
    {
      "value": "Fuel Order",
      "label": "Phiếu dầu trình cơ trưởng"
    },
    {
      "value": "GD",
      "label": "Danh sách tổ bay"
    },
    {
      "value": "HEA",
      "label": "Hàng nặng"
    },
    {
      "value": "HEG",
      "label": "Trứng ấp"
    },
    {
      "value": "HUM",
      "label": "Hộp tro"
    },
    {
      "value": "INAD",
      "label": "Khách bị từ chối nhập cảnh "
    },
    {
      "value": "INF",
      "label": "Khách là trẻ em dưới 2 tuổi"
    },
    {
      "value": "LCC",
      "label": "Hãng hàng không giá rẻ"
    },
    {
      "value": "LDW",
      "label": "Trọng lượng tải chất xếp"
    },
    {
      "value": "LMC",
      "label": "Thay đổi giờ chót"
    },
    {
      "value": "LIR",
      "label": "Bảng hướng dẫn chất xếp"
    },
    {
      "value": "MAAS",
      "label": "Dịch vụ trợ giúp các thủ tục hàng không"
    },
    {
      "value": "Mail Manifest",
      "label": "Danh sách hàng bưu chính của chuyến bay"
    },
    {
      "value": "N/A",
      "label": "Không có thông tin hoặc không áp dụng"
    },
    {
      "value": "OFL",
      "label": "Cắt lại, không chấp nhận vận chuyển"
    },
    {
      "value": "OHG",
      "label": "Hàng quá khổ"
    },
    {
      "value": "OXYG",
      "label": "Khách sử dụng bình oxy"
    },
    {
      "value": "PREG",
      "label": "Khách là phụ nữ có thai"
    },
    {
      "value": "RUSH",
      "label": "Hành lý không đi cùng khách"
    },
    {
      "value": "SEC",
      "label": "Vật phẩm an ninh"
    },
    {
      "value": "SPML",
      "label": "Suất ăn đặc biệt"
    },
    {
      "value": "STA",
      "label": "Thời gian hạ cánh theo lịch"
    },
    {
      "value": "STCR",
      "label": "Khách nằm cáng"
    },
    {
      "value": "STD",
      "label": "Thời gian khởi hành theo lịch"
    },
    {
      "value": "TIM/TIMATIC",
      "label": "Nguồn tra cứu thông tin đi lại"
    },
    {
      "value": "TCI/ITCI",
      "label": "Làm thủ tục liên chặng"
    },
    {
      "value": "UM/ UMNR",
      "label": "Trẻ em dưới 12 tuổi đi tàu bay một mình"
    },
    {
      "value": "VAL/ VAL CARGO",
      "label": "Hàng giá trị cao"
    },
    {
      "value": "VUN",
      "label": "Hàng nhạy cảm"
    },
    {
      "value": "VIP",
      "label": "Hành khách đi tàu bay theo hạng ưu tiên phục vụ - quan trọng"
    },
    {
      "value": "VIPA",
      "label": "Đối tượng hành khách là Chủ tịch nước/ Tổng Bí Thư/ Thủ tướng Chính phủ/ Chủ tịch Quốc hội"
    },
    {
      "value": "WCH R/S/C",
      "label": "Dịch vụ xe lăn phục vụ đến chân cầu thang tàu bay/ cửa tàu bay/ Vị trí ghế ngồi"
    },
    {
      "value": "ZFW",
      "label": "Trọng lượng tàu bay không kể nhiên liệu"
    },
    {
      "value": "HLXT",
      "label": "Hành lý xách tay"
    },
    {
      "value": "HLKG",
      "label": "Hành lý ký gửi"
    },
    {
      "value": "PER",
      "label": "Hàng dễ hư hỏng"
    },
    {
      "value": "PETC",
      "label": "Động vật cảnh vận chuyển trên khoang hành khách"
    },
    {
      "value": "SPEQ",
      "label": "Dụng cụ thể thao"
    },
    {
      "value": "WEAP",
      "label": "Hành lý là súng đạn, công cụ hỗ trợ"
    },
    {
      "value": "CBBG",
      "label": "Hành lý được mua chỗ trên koang hành khách"
    },
    {
      "value": "TTNG",
      "label": "Túi thư ngoại giao"
    },
    {
      "value": "TOW",
      "label": "Trọng lượng cất cánh được phép"
    },
    {
      "value": "COM/ COB",
      "label": "Hàng hóa chuyển phát nhanh dưới dạng hành lý ký gửi"
    },
    {
      "value": "PM",
      "label": "Danh sách hành khách"
    },
    {
      "value": "BNG",
      "label": "Bộ ngoại giao"
    },
    {
      "value": "CAPT",
      "label": "Cơ trưởng"
    },
    {
      "value": "VP TCT",
      "label": "Văn phòng Tổng công ty"
    },
    {
      "value": "Ban Giám đốc",
      "label": "Là Ban Giám đốc công ty VIAGS"
    },
    {
      "value": "Công ty/ VIAGS",
      "label": "Công ty Trách nhiệm hữu hạn một thành viên dịch vụ mặt đất sân bay Việt Nam"
    },
    {
      "value": "Khách hàng",
      "label": "Là các cá nhân hoặc tổ chức sử dụng dịch vụ của VIAGS hoặc có quan hệ đối tác hợp tác với VIAGS."
    },
    {
      "value": "Ngày làm việc",
      "label": "Là các ngày từ Thứ 2 đến Thứ 6, trừ những ngày nghỉ tuần và nghỉ lễ theo quy định của Nhà nước (Lưu ý định nghĩa này có thể bị thay đổi theo quy định của Công ty)."
    },
    {
      "value": "Phòng chức năng",
      "label": "Cơ quan được Tổng giám đốc giao nhiệm vụ quản lý một lĩnh vực hoạt động trong hệ thống quản lý an toàn, an ninh, chất lượng và môi trường VIAGS (VD: Phòng An tòa Chất lượng và An ninh, Phòng Kế hoạch đầu tư…)"
    },
    {
      "value": "Hệ thống quản lý SQMS",
      "label": "Là tập hợp các hệ thống quản lý của VIAGS bao gồm hệ thống quản lý chất lượng, hệ thống quản lý an toàn, hệ thống quản lý an ninh, hệ thống quản lý môi trường, hệ thống quản lý nguồn lực, hệ thống nguồn vật lực, hệ thống quản lý quy trình khai thác, hệ thống quản lý công nghệ thông tin, hệ thống tiếp thị và bán sản phẩm, hệ thống quản lý đào tạo."
    },
    {
      "value": "Cơ quan",
      "label": "Các phòng chức năng/ trung tâm trực thuộc Công ty"
    },
    {
      "value": "Chi nhánh",
      "label": "Các Chi nhánh trực thuộc Công ty, thực hiện việc cung cấp dịch vụ của VIAGS tại các sân bay"
    },
    {
      "value": "Đơn vị",
      "label": "Các Phòng/ Trung tâm trực thuộc Chi nhánh"
    },
    {
      "value": "Service Desk",
      "label": "Hệ thống tiếp nhận thông tin"
    },
    {
      "value": "Đơn vị (người) sử dụng dịch vụ",
      "label": "Cơ quan / Chi nhánh / Đơn vị hoặc cá nhân"
    },
    {
      "value": "IT Helpdesk",
      "label": "chuyên viên CNTT đầu mối tiếp nhận thông tin của người sử dụng dịch vụ. "
    },
    {
      "value": "IT Support ",
      "label": "chuyên viên CNTT trực tiếp sửa chữa/ hỗ trợ tại đơn vị sử dụng dịch vụ"
    },
    {
      "value": "IT Level 2",
      "label": "chuyên viên CNTT phụ trách các công việc chuyên môn với mức xử độ xử lý phức tạp"
    },
    {
      "value": "Cán bộ Công nghệ thông tin",
      "label": "Cán bộ từ cấp Đội trở lên "
    },
    {
      "value": "Đội PT ",
      "label": "Đội phát triển "
    },
    {
      "value": "Chứng chỉ chuyên môn",
      "label": "là chứng chỉ do VIAGS cấp dùng để xác nhận cho học viên đã hoàn thành khóa học chuyên môn nghiệp vụ theo chức danh và có kết quả đạt  theo chương trình đào tạo được Cục Hàng không Việt Nam phê chuẩn. "
    },
    {
      "value": "Giấy chứng nhận",
      "label": "là chứng nhận do VIAGS cấp dùng để xác nhận việc học viên đã có kết quả đạt một hoặc nhiều môn học theo chương trình đào tạo của TTĐT. "
    },
    {
      "value": "Giấy phép nhân viên hàng không",
      "label": "là giấy phép do Cục Hàng không Việt Nam cấp cho các nhân viên có đủ điều kiện và năng lực chuyên môn thực hiện một/nhiều năng định được ghi trong giấy phép. "
    },
    {
      "value": "Giáo viên lý thuyết",
      "label": "giáo viên giảng dạy các nội dung liên quan đến kiến thức chuyên môn, nghiệp vụ, học thuật, các quy trình, quy định"
    },
    {
      "value": "Giáo viên thực hành",
      "label": "giáo viên huấn luyện, kèm cặp, chỉ dẫn và giám sát học viên thực hành các kỹ năng, thao tác nghiệp vụ tại vị trí làm việc, trong phòng thực hành, trên các mô hình mô phỏng hoặc trang thiết bị"
    },
    {
      "value": "Giáo viên giám sát thực hành",
      "label": "giáo viên được chỉ định giám sát nội dung đào tạo thực hành do giáo viên ngoài VIAGS thực hiện"
    },
    {
      "value": "Giáo viên chủ nhiệm",
      "label": "là giáo viên được chỉ định phụ trách lớp đào tạo nhân viên mới, bao gồm: Giáo viên chủ nhiệm lý thuyết và Giáo viên chủ nhiệm thực hành"
    },
    {
      "value": "Giáo viên chủ nhiệm lý thuyết",
      "label": "là giáo viên được Trưởng bộ môn chỉ định phụ trách lớp đào tạo nhân viên mới về nội dung lý thuyết."
    },
    {
      "value": "Giáo viên chủ nhiệm thực hành",
      "label": "là giáo viên được Trưởng bộ môn chỉ định phụ trách lớp đào tạo nhân viên mới về nội dung thực hành."
    },
    {
      "value": "Trợ giảng",
      "label": "Giáo viên/ cán bộ nhân viên tham gia hỗ trợ cho các khóa học. Việc hỗ trợ được thực hiện trong suốt thời gian diễn ra khóa học. "
    },
    {
      "value": "Giáo viên thỉnh giảng",
      "label": "Giáo viên không thuộc VIAGS- có đủ trình độ, năng lực đáp ứng yêu cầu của VIAGS - được VIAGS mời tham gia giảng dạy."
    },
    {
      "value": "Dự giảng",
      "label": "Việc tham gia dự giờ lớp học có liên quan đến môn học được phát triển của giáo viên dự kiến phát triển."
    },
    {
      "value": "Giảng lập",
      "label": "Việc giảng dạy có sự kèm cặp, giám sát của tổ bộ môn hoặc người được phân công."
    },
    {
      "value": "Giảng phê chuẩn",
      "label": "Việc giảng dạy có sự đánh giá của bộ môn hoặc người được phân công nhằm quyết định giáo viên dự kiến phát triển đạt hay không đạt yêu cầu để bổ nhiệm giáo viên."
    },
    {
      "value": "Người đánh giá",
      "label": "Thành viên hội đồng đánh giá tốt nghiệp, được Tổng Giám đốc Công ty TNHH MTV DVMĐ sân bay Việt Nam hoặc người được ủy quyền phê chuẩn."
    },
    {
      "value": "Dạy thí điểm",
      "label": "là việc dạy thử trong phạm vi hẹp để đánh giá, rút kinh nghiệm."
    },
    {
      "value": "Đội Hành chính tổng hợp",
      "label": "là đơn vị tổng hợp xây dựng kế hoạch đào tạo, ngân sách; thực hiện các công tác liên quan dịch vụ đào tạo, quản trị chất lượng và hệ thống; phụ trách các công tác hành chính, tổ chức lớp học, quản lý tài sản, công cụ dụng cụ.    "
    },
    {
      "value": "Bộ môn An ninh an toàn và Phục vụ hàng hóa",
      "label": "Quản lý các môn học kiến thức chung về hàng không dân dụng, các môn an ninh an toàn và phục vụ hàng hóa. "
    },
    {
      "value": "Bộ môn Quan hệ khách hàng và Phát triển kỹ năng",
      "label": "Quản lý các môn học liên quan đến kỹ năng giao tiếp, chăm sóc khách hàng, kỹ năng cá nhân, kỹ năng quản lý và kỹ năng giảng dạy.  "
    },
    {
      "value": "Bộ môn phục vụ hành khách",
      "label": "Quản lý các môn học chuyên môn nghiệp vụ phục vụ hành khách  của Vietnam Airlines và các hãng hàng không. "
    },
    {
      "value": "Bộ môn tài liệu chất xếp",
      "label": "Quản lý các môn học chuyên môn nghiệp vụ cân bằng trọng tải, điều phối chuyến bay, hướng dẫn chất xếp, giám sát sân đỗ, chất xếp hành lý hàng hóa, quản lý khai thác thùng/mâm hành lý hàng hóa, quản trị cơ sở dữ liệu,  trực điều hành."
    },
    {
      "value": "Bộ môn phục vụ sân đỗ",
      "label": "Quản lý các môn học chuyên môn nghiệp vụ vệ sinh tàu bay, điều khiển vận hành trang thiết bị hàng không, phương tiện hoạt động tại khu vực hạn chế của Cảng Hàng không - sân bay, sửa chữa và bảo dưỡng trang thiết bị. "
    },
    {
      "value": "Giấy phép nhân viên hàng không",
      "label": "là giấy phép do Cục Hàng không Việt Nam cấp cho các nhân viên có đủ điều kiện và năng lực chuyên môn thực hiện một/nhiều năng định được ghi trong giấy phép.  "
    },
    {
      "value": "Chương trình đào tạo Kiến thức chung về hàng không dân dụng",
      "label": "bao gồm các môn học liên quan kiến thức chung về hàng không dân dụng theo qui định của Cục Hàng không. "
    },
    {
      "value": "Chương trình đào tạo Quan hệ khách hàng",
      "label": "bao gồm các môn học liên quan đến kỹ năng giao tiếp và chăm sóc khách hàng.   "
    },
    {
      "value": "Chương trình đào tạo Phát triển kỹ năng",
      "label": "bao gồm các môn học liên quan đến kỹ năng cá nhân, kỹ năng quản lý và kỹ năng giảng dạy"
    },
    {
      "value": "Chương trình đào tạo Nghiệp vụ Phục vụ hành khách",
      "label": "bao gồm các môn học chuyên môn nghiệp vụ phục vụ hành khách  của Vietnam Airlines và các hãng hàng không. "
    },
    {
      "value": "Chương trình đào tạo Nghiệp vụ Tài liệu chất xếp",
      "label": "bao gồm các môn học chuyên môn nghiệp vụ cân bằng trọng tải, điều phối chuyến bay, hướng dẫn chất xếp, giám sát sân đỗ, chất xếp hành lý hàng hóa, quản lý khai thác thùng/mâm hành lý hàng hóa, quản trị cơ sở dữ liệu,  trực điều hành."
    },
    {
      "value": "Chương trình đào tạo Nghiệp vụ Phục vụ sân đỗ",
      "label": "bao gồm các môn học chuyên môn nghiệp vụ vệ sinh tàu bay, điều khiển vận hành trang thiết bị hàng không, phương tiện hoạt động tại khu vực hạn chế của Cảng Hàng không - sân bay, sửa chữa và bảo dưỡng trang thiết bị. "
    },
    {
      "value": "Hệ thống quản lý an toàn",
      "lable": "Hệ thống quản lý an toàn là một công cụ quản lý để quản lý an toàn bởi một tổ chức. Hệ thống này được thiết lập và thực hiện với mục đích tối thiểu nhằm: nhận diện các mối nguy hiểm và đánh giá, kiểm soát và giảm thiểu rủi ro; Đảm bảo rằng các biện pháp khắc phục cần thiết để duy trì một mức độ an toàn có thể chấp nhận được thực hiện ; Theo dõi liên tục và đánh giá thường xuyên mức độ an toàn đã đạt được; và nhằm nâng cấp liên tục đối với mức độ an toàn tổng thể. Bốn chức năng chính tạo nên hệ thống quản lý an toàn là:a. Chính sách - Mục tiêu - Vai trò - trách nhiệm: Xác định rõ định hướng về an toàn của một tổ chức; đồng thời thể hiện rõ vai trò, trách nhiệm của đội ngũ quản lý trong công tác quản lý an toàn của một tổ chức;b. Quản lý rủi ro an toàn: một hệ thống chính thức để xác nhận rủi ro và quản lý rủi ro an toàn để kiểm soát rủi ro ở mức độ có thể chấp nhận được. Đảm bảo an toàn: khi những sự kiểm soát này được xác định, người khai thác phải đảm bảo chúng liên tục được thực hiện và tiếp tục có hiệu quả trong môi trường luôn thay đổi. Chức năng đảm bảo an toàn sử dụng các khái niệm và các quá trình quản lý chất lượng. Thúc đẩy an toàn: người khai thác phải tăng cường an toàn như là giá trị nòng cốt với những sự thực hành hỗ trợ văn hoá an toàn đúng mực."
    },
    {
      "value": "An toàn",
      "lable": "Là trạng thái mà khả năng gây hại đến con người hoặc tài sản được giảm xuống và duy trì bằng hay dưới một mức độ chấp nhận được thông qua quá trình liên tục nhận diện các mối nguy hiểm và quản lý an toàn rủi ro."
    },
    {
      "value": "Tai nạn",
      "lable": "Là một sự kiện xuất hiện không có kế hoạch làm gián đoạn hoạt động của tổ chức và có thể gây thương tích hoặc gây thiệt hại về người và tài sản;"
    },
    {
      "value": "Sự cố",
      "lable": "là sự xuất hiện một sự kiện, tình trạng hoặc tình huống phát sinh trong quá trình hoạt động khai thác có thể dẫn tổn hại đến sức khoẻ hoặc tử vong cho con người hoặc gây tổn thất, hư hại tài sản hoặc làm ảnh hưởng đến quá trình khai thác khác với tai nạn, sự cố dùng để chỉ sự kiện không mong đợi xuất hiện nhưng chưa gây ra thiệt hại về người và tài sản tuy nhiên chứa đựng mối nguy, nguy cơ tiềm tàng (near miss or dangerous occurrence)"
    },
    {
      "value": "Nguy hiểm",
      "lable": "Được xác định như là một trạng thái hoặc một đối tượng với nguy cơ gây ra thương tích đối với người, hư hại đối với trang thiết bị hoặc các cấu trúc, sự mất mát vật chất hoặc việc giảm khả năng thực hiện một chức năng đượcđịnh trước."
    },
    {
      "value": "Mối nguy",
      "lable": "Là một nguồn, một yếu tố, một tình huống hoặc một hành động có tiềm năng gây ra tổn hại đối với con người (như tổn thương hay gây hại đến sức khỏe hoặc kết hợp cả hai), tài sản của VIAGS và của khách hàng (tàu bay, thiết bị, cơ sở vật chất…) hay gây tổn thất nguồn lực, hoặc giảm khả năngthực hiện sản xuất kinh doanh của VIAGS."
    },
    {
      "value": "Rủi ro",
      "lable": "Là sự kết hợp giữa khả năng xảy ra của những mối nguy và mức độ ảnh hưởng do mối nguy gây ra."
    },
    {
      "value": "Rủi ro chấp nhận được",
      "lable": "Là những rủi ro nằm trong giới hạn an toàn cho phép. Giới hạn an toàn đượcVIAGS xác định dựa trên cơ sở yêu cầu của luật định, của khách hàng và định hướng an toàn do Ban lãnh đạo VIAGS xác định."
    },
    {
      "value": "Khả năng xảy ra",
      "lable": "Là mức độ thường xuyên, tần suất xảy ra của mối nguy."
    },
    {
      "value": "Mức độ ảnh hưởng",
      "lable": "Là hậu quả mà mối nguy có thể mang lại."
    },
    {
      "value": "Mức độ an toàn",
      "lable": "Là đặc trưng cơ bản của hệ thống quản lý an toàn, nó biểu thị cho chất lượngcủa hệ thống quản lý an toàn. Mức độ an toàn được thể hiện qua bộ các chỉ số thực hiện an toàn;"
    },
    {
      "value": "Các chỉ số thực hiện an toàn",
      "lable": "Là bộ các thông số đặc trưng, điển hình cho mức độ thực hiện an toàn của hệ thống;"
    },
    {
      "value": "Các mục tiêu thưc hiện an toàn",
      "lable": "Là các mục tiêu cụ thể của mức độ an toàn, thể hiện mức mong muốn đạt được của từng chỉ số thực hiện an toàn;"
    },
    {
      "value": "Mức độ an toàn tối thiểu có thể chấp nhận (ALS)",
      "lable": "Là biểu thị mức độ thực hiện an toàn tối thiểu (mức cảnh báo) đối với từng chỉ số thực hiện an toàn phải được đảm bảo bởi hệ thống quản lý an toàn hiện thời của tổ chức."
    },
    {
      "value": "Khuyến cáo an toàn",
      "lable": "Là một yêu cầu chính thức, dựa trên sự điều tra an toàn được làm đối với một tổ chức để thông báo, triển khai những yêu cầu về hệ thống để duy trì hoặc cải thiện mức độ an toàn."
    },
    {
      "value": "Văn hóa an toàn",
      "lable": "Là chỉ số căn bản cho việc đạt được văn hóa an toàn"
    },
    {
      "value": "ACARS",
      "lable": "Hệ thống kết nối dữ liệu giữa tàu bay và mặt đất"
    },
    {
      "value": "ACU",
      "lable": "Xe cấp khí lạnh tàu bay"
    },
    {
      "value": "AHGSE",
      "lable": "Phương tiện khu bay: Thiết bị hỗ trợ mặt đất tại sân bay hay còn gọi tắt là phương tiện kỹ thuật phục vụ mặt đất hay phương tiện khu bay"
    },
    {
      "value": "AHM - Airport Handling Manual",
      "lable": "Sổ tay hướng dẫn khai thác mặt đất tại sân bay."
    },
    {
      "value": "An toàn",
      "lable": "Là trạng thái mà khả năng gây hại cho người hoặc hủy hoại tài sản được giảm thiểu và duy trì tại hoặc dưới mức độ chấp nhận được thông qua quá trình liên tục nhận dạng mối nguy hiểm và quản lý rủi ro."
    },
    {
      "value": "AOG",
      "lable": "Tàu bay kỹ thuật chờ sửa chữa"
    },
    {
      "value": "Booking list/ Pre-manifest",
      "lable": "Danh sách hàng hóa dự kiến đi trên một chuyến bay"
    },
    {
      "value": "BD10",
      "lable": "Chứng từ vận chuyển hàng bưu chính nội địa"
    },
    {
      "value": "Briefing",
      "lable": "Triển khai thông tin"
    },
    {
      "value": "Cargo Allowance",
      "lable": "Điện chấp nhận hàng hoá"
    },
    {
      "value": "Cargo Manifest",
      "lable": "Danh sách hàng hóa của chuyến bay"
    },
    {
      "value": "Cargo spot",
      "lable": "Hệ thống làm thủ tục hàng hóa"
    },
    {
      "value": "CN38",
      "lable": "Chứng từ vận chuyển hàng bưu chính quốc tế"
    },
    {
      "value": "Điện CPM, LDM, MVT, PSM, PTM, ROC,...",
      "lable": "Tên các loại điện văn cung cấp thông tin khai thác"
    },
    {
      "value": "Đô-ly (Dolly)/ Trô-ly (Trolly)",
      "lable": "Là mooc chuyên dùng trong ngành hàng không dùng để vận chuyển các mâm / thùng hàng hàng không chứa hành lý, hàng hóa hoạt động trên khu bay."
    },
    {
      "value": "DTB/Database",
      "lable": "Cơ sở dữ liệu"
    },
    {
      "value": "DPT",
      "lable": "Xe phục vụ đặc biệt"
    },
    {
      "value": "Đường cất hạ cánh",
      "lable": "Là một khu vực hình chữ nhật được xác định trên mặt đất tại khu bay dùng cho tàu bay cất cánh và hạ cánh.  Đường cất hạ cánh có chiều dài  tối thiểu cần thiết cho tàu bay cất hạ cánh với tải trọng cất cánh tối đa ở độ cao mực nước biển, điều kiện khí quyển tiêu chuẩn, lặng gió và độ dốc đường cất hạ cánh bằng không."
    },
    {
      "value": "Đường công vụ",
      "lable": "Là khu vực dành cho các phương tiện trang thiết bị di chuyển trên khu bay và sân đỗ tàu bay."
    },
    {
      "value": "Go-show",
      "lable": "Khách không có tên trong danh sách đã xác nhận chỗ của chuyến bay, vé chưa xác nhận chỗ, có đi trên chuyến bay; hoặc khách được chuyển từ chuyến bay khác"
    },
    {
      "value": "Hàng bưu chính/ bưu kiện",
      "lable": "Là hàng của Bưu điện được vận chuyển theo hợp đồng với hãng vận chuyển, bao gồm tất cả các công văn, thư, báo, bưu phẩm, bưu kiện."
    },
    {
      "value": "Hệ thống B-DCS/ Easy tag/ Manual",
      "lable": "Các hệ thống làm thủ tục dự phòng/ làm thủ công"
    },
    {
      "value": "Khu bay",
      "lable": "Là khu vực của sân bay bao gồm sân đỗ tàu bay, đường lăn và đường cất hạ cánh."
    },
    {
      "value": "Khu vực an toàn vị trí đỗ tàu bay",
      "lable": "Là khu vực hạn chế đối với xe và thiết bị phục vụ tàu bay, được đánh dấu bằng vạch liền nét màu đỏ xung quanh vị trí đỗ tàu bay."
    },
    {
      "value": "Kiểm định kỹ thuật an toàn",
      "lable": "Là hoạt động đánh giá tình trạng kỹ thuật của đối tượng kiểm định theo quy định tại các quy chuẩn kỹ thuật quốc gia, tiêu chuẩn quốc gia về an toàn lao động tương ứng."
    },
    {
      "value": "Kiểm tra trực quan",
      "lable": "Là việc nhân viên trực tiếp sử dụng tay, mắt và các giác quan khác để kiểm tra phát hiện bất thường."
    },
    // {
    //   "value": "L",
    //   "lable": "Bên trái theo hướng mũi của tàu bay"
    // },
    {
      "value": "L&F",
      "lable": "Quầy tiếp nhận giải quyết các khiếu nại về hành lý bất thường (Lost and Found)"
    },
    {
      "value": "Loadsheet",
      "lable": "Bảng tải"
    },
    {
      "value": "Mooc (Cart)",
      "lable": "Dùng để chỉ các thiết bị có bánh xe, di chuyển được nhờ lực kéo từ bên ngoài. Dùng để chở hành lý, hàng hóa, bưu kiện rời hoặc chở các thiết bị phục vụ công tác bảo dưỡng tàu bay như chóp, chèn, bình khí ni tơ, lốp tàu bay…"
    },
    {
      "value": "No-show",
      "lable": "Khách có tên trong danh sách đã xác nhận chỗ của chuyến bay, không làm thủ tục, không đi trên chuyến bay; hoặc khách có tên trong danh sách đã xác nhận chỗ của chuyến bay, đã làm thủ tục, không đi trên chuyến bay vì các lý do như xuất nhập cảnh, tự bỏ chuyến, v.v."
    },
    {
      "value": "NOTOC (Notification To Captain)",
      "lable": "Phiếu thông tin trình Cơ trưởng về hàng nguy hiểm, hàng đặc biệt chất xếp trên tàu bay."
    },
    {
      "value": "PDU (Power Drive Unit)",
      "lable": "Bánh xe lăn chuyển ULD hầm hàng"
    },
    {
      "value": "Phương án khẩn nguy",
      "lable": "Là phương án xây dựng có sự phối hợp của nhiều lực lượng liên quan nhằm sẵn sàng đối phó với các hành vi can thiệp bất hợp pháp vào hoạt động hàng không dân dụng."
    },
    {
      "value": "Phương tiện chuyên dùng trong ngành hàng không hoạt động trên khu bay",
      "lable": "Là phương tiện (bao gồm các loại xe, mooc, thiết bị không có bánh xe di chuyển được, có gắn động cơ hoặc không gắn động cơ), có kết cấu đặc thù hoặc được hoán cải, trang bị những thiết bị để thực hiện việc vận chuyển hành khách, hành lý, hàng hóa, bưu phẩm, bưu kiện bằng đường hàng không; các thiết bị hàng không phục vụ việc khai thác tàu bay và họat động bảo dưỡng tàu bay."
    },
    {
      "value": "Pre-manifest/Booking list",
      "lable": "Danh sách hàng hóa dự kiến đi trên một chuyến bay"
    },
    // {
    //   "value": "R",
    //   "lable": "Bên phải theo hướng mũi của tàu bay"
    // },
    {
      "value": "Sabre",
      "lable": "Hệ thống làm thủ tục Hãng VNA"
    },
    {
      "value": "Sân đỗ quân sự",
      "lable": "Sử dụng cho hoạt động của tàu bay dân dụng theo thỏa thuận giữa người khai thác cảng hàng không sân bay và đơn vị quân đội liên quan với điều kiện đáp ứng các yêu cầu về kỹ thuật và tiêu chuẩn đảm bảo khai thác sân đỗ dân dụng."
    },
    {
      "value": "Sân đỗ tàu bay",
      "lable": "Là khu vực được xác định trong sân bay dành cho tàu bay đỗ để phục vụ hành khách lên, xuống, xếp, dỡ hành lý, thư, bưu phẩm, bưu kiện, hàng hoá, tiếp nhiên liệu, cung ứng suất ăn, phục vụ kỹ thuật hoặc bảo dưỡng tàu bay."
    },
    {
      "value": "SLA",
      "lable": "Cam kết chất lượng dịch vụ"
    },
    {
      "value": "Thiết bị",
      "lable": "Là thuật ngữ dùng để chỉ chung dụng cụ, đồ vật, máy móc… để con người sử dụng trong lao động, trong TCKT này chúng được lắp đặt trên xe hoặc mooc hoạt động trên khu bay."
    },
    {
      "value": "Thiết bị (Xe/mooc) điều hoà không khí",
      "lable": "Là phương tiện làm mát, làm ấm hoặc làm thông gió tàu bay."
    },
    {
      "value": "Thiết bị cấp điện cho tàu bay (GPU)",
      "lable": "Là phương tiện dùng để cấp điện một chiều và xoay chiều với điện áp, tần số phù hợp với yêu cầu của tàu bay."
    },
    {
      "value": "Thiết bị cấp khí khởi động tàu bay (ASU)",
      "lable": "Là phương tiện dùng để cấp khí phù hợp để kiểm tra và khởi động động cơ tàu bay và khí phục vụ hệ thống làm mát hoặc sưởi ấm tàu bay."
    },
    {
      "value": "Thiết bị đo lường",
      "lable": "Cân, đồng hồ, thước…"
    },
    {
      "value": "Tờ khai gửi hàng (shipper's letter of instruction - SLI)",
      "lable": "Tờ khai gửi hàng là mẫu dành cho người gửi khai báo thông tin gửi hàng, làm cơ sở cho việc lập không vận đơn. Tờ khai này còn có thể được dùng để xác nhận số lượng, khối lượng, thể tích của lô hàng sau khi đã kiểm tra, chấp nhận. Tờ khai này có thể do hãng vận chuyển hoặc công ty PVHH ban hành."
    },
    {
      "value": "Turn around",
      "lable": "Chuyến bay quay đầu"
    },
    {
      "value": "ULD (Unit Load Device)",
      "lable": "Thiết bị trong đó hàng hóa, hành lý và/hoặc bưu kiện được xếp vào và sau đó được coi như một đơn vị hàng hóa để xếp lên tàu bay (gồm: mâm (pallet), thùng (container), mooc (cart.)."
    },
    {
      "value": "Xe cấp nước sạch",
      "lable": "Là phương tiện dùng để chuyên chở và cung cấp nước sạch lên tàu bay. Trong định nghĩa này nước sạch được hiểu là nước uống được đảm bảo đáp ứng theo Quy chuẩn Việt Nam QCVN 6-1:2010/BYT ban hành kèm theo Thông tư số 34/2010/TT-BYT Ban hành qui chuẩn kỹ thuật quốc gia đối với nước khoáng thiên nhiên và nước uống đóng chai ngày 02/6/2010 của Bộ Y tế hoặc QCVN 01:2009/BYT Quy chuẩn kỹ thuật quốc gia về chất lượng nước ăn uống (National technical regulation on drinking water quality) do Bộ Y tế ban hành theo Thông tư số: 04/2009/TT-BYT ngày 17 tháng 6 năm 2009."
    },
    {
      "value": "Xe chở cán bộ, công nhân viên trên khu bay",
      "lable": "Là phương tiện dùng để vận chuyển cán bộ, công nhân viên giữa nhà ga cảng hàng không/khu vực làm việc và tàu bay trên khu bay."
    },
    {
      "value": "Xe đầu kéo",
      "lable": "Là phương tiện dùng để kéo các đô-ly, Trô-ly, mooc chở hàng hóa và các phương tiện không tự hành khác."
    },
    {
      "value": "Xe hút vệ sinh",
      "lable": "Là phương tiện dùng để hút chất thải lỏng trong buồng vệ sinh tàu bay, cấp nước rửa buồng vệ sinh tàu bay."
    },
    {
      "value": "Xe kéo, đẩy tàu bay",
      "lable": "Là phương tiện dùng để kéo, đẩy tàu bay vào và ra khỏi vị trí đỗ của tàu bay và phục vụ công tác cứu nạn tàu bay."
    },
    {
      "value": "Xe nâng hàng",
      "lable": "Là phương tiện dùng để chất xếp/dỡ hành lý, hàng hoá được đóng trong mâm, thùng hàng lên, xuống tàu bay."
    },
    {
      "value": "Xe nâng vật tư, hàng hóa",
      "lable": "Là phương tiện chuyên dùng trong ngành hàng không để chuyên chở và nâng các vật tư, vật phẩm, dụng cụ phục vụ tàu bay."
    },
    {
      "value": "Xe phục vụ đặt biệt",
      "lable": "Là phương tiện dành riêng cho hành khách không có khả năng tự di chuyển bình thường, được trang bị các thiết bị chuyên dùng để giúp các hành khách lên, xuống tàu bay an toàn thuận lợi."
    },
    {
      "value": "Xe thang/thang kéo đẩy tay",
      "lable": "Là phương tiện dùng để hành khách và những người được phép làm việc trên tàu bay, lên xuống tàu bay."
    },
    {
      "value": "Xe trung chuyển thùng hàng",
      "lable": "Là phương tiện dùng để chuyển các mâm, thùng hàng chuyên dùng trong ngành hàng không từ thiết bị chuyên chở này sang thiết bị chuyên chở khác."
    },
    {
      "value": "Xe xúc nâng",
      "lable": "là phương tiện dùng để xúc, nâng hàng hóa, di chuyển hàng hóa trong khu vực sân đỗ, các kho bãi, các nhà ga hàng hóa."
    },
    {
      "value": "Xe/mooc băng chuyền",
      "lable": "Là phương tiện dùng để xếp dỡ hàng hoá, hành lý, bưu phẩm, bưu kiện, thư ở dạng rời lên xuống tàu bay."
    },
    {
      "value": "Yêu cầu về an toàn",
      "lable": "Là yêu cầu cần phải đạt được chỉ số thực hiện an toàn và mục tiêu thực hiện an toàn, bao gồm phương thức khai thác; công nghệ, hệ thống kỹ thuật, thiết bị bảo đảm hoạt động bay."
    },
    {
      "value": "Hệ thống quản lý",
      "lable": "Hệ thống quản lý là hệ thống để thiết lập chính sách và mục tiêu và để đạt được các mục tiêu đó. Một hệ thống quản lý của một tổ chức có thể bao gồm các hệ thống quản lý khác nhau, ví dụ như hệ thống quản lý chất lượng, hệ thống quản lý tài chính, hay hệ thống quản lý môi trường."
    },
    {
      "value": "Hệ thống quản lý chất lượng",
      "lable": "Là hệ thống quản lý để định hướng và kiểm soát một tổ chức về mặt chất lượng. Mục đích của hệ thống quản lý chất lượng là cung cấp sản phẩm/dịch vụ có chất lượng ổn định. Cải tiến liên tục kết quả thực hiện và tăng cao khả năng đáp ứng yêu cầu của khách hàng."
    },
    {
      "value": "Chất lượng",
      "lable": "Là khái niệm đặc trưng cho khả năng thoả mãn nhu cầu của khách hàng. Vì vậy, sản phẩm/dịch vụ nào không đáp ứng được nhu cầu của khách hàng thì bị coi là kém chất lượng cho dù trình độ công nghệ tạo ra sản phẩm/dịch vụ có hiện đại đến đâu đi nữa.Đánh giá chất lượng cao hay thấp phải đứng trên quan điểm khách hàng. Cùng một mục đích sử dụng như nhau, sản phẩm/dịch vụ nào thoả mãn nhu cầu khách hàng cao hơn thì có chất lượng cao hơn.Yêu cầu của khách hàng đối với sản phẩm hay dịch vụ thường là: tốt, hiệu quả, chuyên nghiệp, thuận lợi, giá cả phù hợp…"
    },
    {
      "value": "Sự thỏa mãn của khách hàng",
      "lable": "Sự cảm nhận của khách hàng về mức độ đáp ứng yêu cầu của mình."
    },
    {
      "value": "Chính sách",
      "lable": "Chính sách là quan điểm, mong muốn và định hướng chung của một tổ chức có liên quan đến từng khía cạnh (chất lượng, an toàn…) được lãnh đạo cao nhất công bố chính thức"
    },
    {
      "value": "Mục tiêu",
      "lable": "Mục tiêu được hiểu khái quát nhất là cái đích cần đạt tới. Mỗi doanh nghiệp cũng như từng bộ phận của nó đều có mục tiêu của mình. Mục tiêu của doanh nghiệp có thể được xác định cho toàn bộ quá trình tồn tại và phát triển và cũng có thể chỉ gắn với từng giai đoạn phát triển nhất định của nó. Hệ thống mục tiêu của doanh nghiệp mang đặc điểm chung là thể hiện các mong muốn phải đạt tới các kết quả cụ thể nhất định trong thời kỳ chiến lược."
    },
    {
      "value": "Đại diện lãnh đạo",
      "lable": "Là người chịu trách nhiệm cao nhất về chất lượng của tổ chức. Đây là môṭ vi ̣trí quản lý vô cùng quan troṇ g, quyết điṇ h quá trình thiết lâp̣ , vâṇ   hành, cải tiến và  sự thành công của hê ̣ thống quản lý chất lượng, đem hiệu quả cho danh nghiệp ."
    },
    {
      "value": "Kế hoạch chất lượng",
      "lable": "Là việc xác định: Loại chất lượng mà bạn mong muốn, Có thể đạt được mức độ chất lượng này như thế nào, Chất lượng sẽ được đo như thế nào. Thường xuyên, khách hàng không cụ thể mức độ chất lượng mong muốn, chỉ nói một cách đơn giản, chúng tôi muốn chất lượng tốt nhất...."
    },
    {
      "value": "Đánh giá (chất lượng, an toàn….)",
      "lable": "Là một quá trình kiểm tra, đánh giá một hệ thống (hệ thống quản lý chất lượng, hệ thống quản lý an toàn….) để tìm ra các  điểm phù hợp hay không phù hợp của từng hệ thống trong một tổ chức. Kết quả đánh giá là các thông tin, đầu vào quan trọng cho các quá trình cải tiến. Việc đánh giá (chất lượng, an toàn) có thể tiến hành bởi một đoàn đánh giá nội bộ hoặc một đoàn đánh giá độc lập và có thể kết hợp đánh giá nhiều hệ thống quản lý trong một lần đánh giá."
    },
    {
      "value": "Giám sát",
      "lable": "Là quá trình theo dõi, đo lường và chấn chỉnh việc thực hiện nhằm đảm báo cho các mục tiêu, kế hoạch của dự án, chương trình, kế hoạch được hoàn thành một cách có hiệu quả. Là hoạt động theo dõi thường xuyên, kiểm tra định kỳ, đo lường theo kế hoạch hoặc đột xuất các quá trình theo các tiêu chuẩn, quy định nhằm đảm bảo mục tiêu và hiệu quả của hệ thống quản lý."
    },
    {
      "value": "Kiểm tra",
      "lable": "Là xem xét tình hình thực tế bằng cách quan sát trực tiếp và xét đoán kèm theo bằng phép đo, thử nghiệm hay định cỡ thích hợp để đánh giá, nhận xét giá sự phù hợp."
    },
    {
      "value": "Hệ thống tài liệu",
      "lable": "Một tập hợp các tài liệu và hồ sơ được gọi là hệ thống tài liệu."
    },
    {
      "value": "Tài liệu",
      "lable": "Là hình thức cung cấp các thông tin về cách thức tiến hành các hoạt động và quá trình một cách nhất quá; những tài liệu này có thể bao gồm các thủ tục, hướng dẫn công việc và bản vẽ; có thể thay đổi cho phù hợp với tình hình thực tế."
    },
    {
      "value": "Hồ sơ",
      "lable": "Là tài liệu công bố kết quả đạt được hay cung cấp bằng chứng về các hoạt động thực hiện hay kết quả đạt được trong quá khứ, do đó không thể sửa đổi."
    },
    {
      "value": "Rủi ro",
      "lable": "Là một sự kiện không chắc chắn có thể xảy ra và ảnh hưởng tốt hoặc xấu đến mục tiêu phát triển của VIAGS. Một rủi ro có thể xuất phát từ một hay nhiều nguyên nhân và nếu nó xảy ra thì có thể dẫn đến nhiều tác động. Một nguyên nhân có thể là một tình huống cụ thể, các đòi hỏi tiềm năng, sự giả định, một sự hạn chế, hay một điều kiện thuận lợi cho các kết quả tiêu cực - tích cực xảy ra."
    },
    {
      "value": "Thay đổi",
      "lable": "Có thể được hiểu một cách khái quát như sự mở rộng, cấu trúc lại hay sự thay đổi của hệ thống, thiết bị, chương trình, sản phẩm, dịch vụ, quy trình, điều kiện (môi trường hoạt động) mới được đưa vào hoặc bổ sung vào hệ thống, thiết bị, chương trình, sản phẩm, dịch vụ, quy trình, môi trường hiện có nhằm đạt được mục tiêu nào đó;"
    },
    {
      "value": "Sự vụ/ sự việc",
      "lable": "Là các sự việc được phát hiện trong quá trình khai thác, gây hậu quả hoặc có nguy cơ gây hậu quả ảnh hưởng đến an toàn, an ninh và chất lượng phục vụ của VIAGS."
    },
    {
      "value": "Thông tin phản hồi",
      "lable": "Là những dạng ý kiến thu thập được qua những kênh thông tin khác nhau (đối thoại, email, thư tay, phương tiện thông tin đại chúng…) phản ánh chất lượng cung ứng dịch vụ hoặc liên quan đến hệ thống quản trị chất lượng của VIAGS."
    },
    {
      "value": "Không tuân thủ",
      "lable": "Khi một yêu cầu nào đó của luật định không được chấp hành"
    },
    {
      "value": "Điểm không phù hợp",
      "lable": "Là sự chưa đáp ứng và thỏa mãn các yêu cầu của khách hàng, của cấp trên, của đơn vị hoặc không đáp ứng các quy trình, quy định, các chỉ tiêu quản lý, mục tiêu quản lý của VIAGS."
    },
    {
      "value": "Sự khắc phục",
      "lable": "Là việc thực hiện các hành động xử lý đối với điểm không phù hợp."
    },
    {
      "value": "Hành động khắc phục",
      "lable": "Là tập hợp các hành động cần thực hiện để loại bỏ các nguyên nhân của sự/điểm không phù hợp nhằm ngăn ngừa sự tái diễn các tình trạng không mong muốn khác ảnh hưởng tới hệ thống quản lý (chất lượng, an toàn, an ninh…)."
    },
    {
      "value": "Hành động phòng ngừa",
      "lable": "Hành động được tiến hành để loại bỏ nguyên nhân của sự không phù hợp tiềm tàng hay các tình trạng không mong muốn tiềm tàng khác ảnh hưởng đến hệ thống chất lượng và hệ thống quản lý an toàn."
    },
    {
      "value": "Ban CNTT ",
      "lable": "là Ban Công nghệ thông tin TCTHKVN"
    },
    {
      "value": "Đội ĐBVH ",
      "lable": "là Đội Đảm bảo vận hành Công nghệ thông tin Công ty VIAGS"
    },
    {
      "value": "Đơn vị phụ trách",
      "lable": "- Phòng CNTT là đơn vị phụ trách hệ thống Thư điện tử, Portal, Sabre DCS và là đầu mối liên hệ chính với Ban CNTT- Chịu trách nhiệm cập nhật thay đổi và phổ biến các nội dung trong các Quy định liên quan đến các Cơ quan, đơn vị liên quan"
    },
    {
      "value": "Đơn vị sử dụng ",
      "lable": "- Các Cơ quan của Công ty VIAGS Các Đơn vị thuộc Công ty VIAGS"
    },
    {
      "value": "CAAV/ CHKVN",
      "label": "Cục Hàng không Việt Nam"
    },
    {
      "value": "CHKTSN",
      "label": "Cảng Hàng không Quốc tế Tân Sơn Nhất"
    },
    {
      "value": "Bộ GTVT",
      "label": "Bộ Giao thông vận tải"
    },
    {
      "value": "IATA",
      "label": "Hiệp hội Vận tải Hàng không Quốc tế"
    },
    {
      "value": "ICAO",
      "label": "Tổ chức Hàng không Dân dụng Quốc tế"
    },
    {
      "value": "ISO",
      "label": "Tổ chức tiêu chuẩn hóa Quốc tế"
    },
    {
      "value": "ISAGO",
      "label": "IATA Safety Audit for Ground Operations hệ thống đảm bảo tiêu chuẩn an toàn trong các hoạt động phục vụ hàng không tại mặt đất"
    },
    {
      "value": "VNA/ TCT/ TCTHKVN",
      "label": "Tổng Công ty Hàng không Việt Nam"
    },
    {
      "value": "VNA",
      "label": "Tổng Công ty Hàng không Việt Nam"
    },
    {
      "value": "TCT",
      "label": "Tổng Công ty Hàng không Việt Nam"
    },
    {
      "value": "TCTHKVN",
      "label": "Tổng Công ty Hàng không Việt Nam"
    },
    {
      "value": "VAECO",
      "label": "Công ty TNHH MTV Kỹ thuật tàu bay"
    },
    {
      "value": "VIAGS",
      "label": "Công ty TNHH MTV Dịch vụ Mặt đất Sân bay Việt Nam"
    },
    {
      "value": "VIAGS-NBA",
      "label": "Công ty Trách nhiệm hữu hạn một thành viên mặt đất sân bay Việt Nam- Chi nhánh Nội Bài"
    },
    {
      "value": "VIAGS-DAD",
      "label": "Công ty Trách nhiệm hữu hạn một thành viên mặt đất sân bay Việt Nam- Chi nhánh Đà Nẵng"
    },
    {
      "value": "VIAGS-TSN",
      "label": "Công ty Trách nhiệm hữu hạn một thành viên mặt đất sân bay Việt Nam- Chi nhánh Tân Sơn Nhất"
    },
    {
      "value": "HĐTV",
      "label": "Hội đồng thành viên"
    },
    {
      "value": "BGĐ",
      "label": "Ban Giám Đốc"
    },
    {
      "value": "BGĐ TSN",
      "label": "Bam Giám Đốc Chi nhánh Tân Sơn Nhất"
    },
    {
      "value": "BGĐ DAD",
      "label": "Bam Giám Đốc Chi nhánh Đà Nẵng"
    },
    {
      "value": "BGĐ NBA",
      "label": "Bam Giám Đốc Chi nhánh Nội Bài"
    },
    {
      "value": "ATCLAN",
      "label": "Phòng An toàn chất lượng và An ninh"
    },
    {
      "value": "CNTT",
      "label": "Phòng Công nghệ thông tin"
    },
    {
      "value": "QLCL",
      "label": "Quản lý chất lượng"
    },
    {
      "value": "TCNL",
      "label": "Phòng Tổ chức và Nhân lực"
    },
    {
      "value": "KDTT",
      "label": "Phòng Kinh doanh"
    },
    {
      "value": "VPCT",
      "label": "Văn phòng Công ty"
    },
    {
      "value": "VPĐĐ",
      "label": "Văn Phòng Đảng đoàn"
    },
    {
      "value": "KHĐT",
      "label": "Phòng Kế hoạch đầu tư"
    },
    {
      "value": "TCKT",
      "label": "Phòng Tài chính kế toán"
    },
    {
      "value": "TTĐT",
      "label": "Trung tâm đào tạo"
    },
    {
      "value": "TT SCBDTTB",
      "label": "Trung tâm sửa chữa bảo dưỡng trang thiết bị"
    },
    {
      "value": "TT KST",
      "label": "Trung tâm kiểm soát tải"
    },
    {
      "value": "TT DVSĐ",
      "label": "Trung tâm dịch vụ sân đỗ"
    },
    {
      "value": "TT DVTT",
      "label": "Trung tâm dịch vụ trên tàu"
    },
    {
      "value": "TT PVHK",
      "label": "Trung tâm phục vụ hành khách"
    },
    {
      "value": "TTĐH",
      "label": "Trung tâm điều hành"
    },
    {
      "value": "CQ/ ĐV",
      "label": "Cơ quan, đơn vị"
    },
    {
      "value": "SQMS",
      "label": "Hệ thống quản trị an toàn chất lượng"
    },
    {
      "value": "UBAT",
      "label": "Ủy ban an toàn"
    },
    {
      "value": "AMS",
      "label": "Aircraft Maintenance Schedule: Chương trình bảo dưỡng máy bay"
    },
    {
      "value": "ANSC",
      "label": "An ninh soi chiếu"
    },
    {
      "value": "ATSĐ",
      "label": "An toàn sân đỗ"
    },
    {
      "value": "BD-SC",
      "label": "Bảo dưỡng - sửa chữa"
    },
    {
      "value": "BHLĐ",
      "label": "Bảo hộ lao động"
    },
    {
      "value": "BPKP",
      "label": "Biện pháp khắc phục"
    },
    {
      "value": "CBCNV",
      "label": "Cán bộ công nhân viên"
    },
    {
      "value": "CBTT",
      "label": "Cân bằng trọng tải"
    },
    {
      "value": "CCDC",
      "label": "Công cụ dụng cụ"
    },
    {
      "value": "CDT",
      "label": "Chất dỡ tải"
    },
    {
      "value": "CT QLKT",
      "label": "Chương trình quản lý khai thác trang thiết bị"
    },
    {
      "value": "CUDV",
      "label": "Cung ứng dịch vụ"
    },
    {
      "value": "ĐHKT",
      "label": "Điều hành khai thác"
    },
    {
      "value": "GL",
      "label": "Gate leader: nhân viên chịu trách nhiệm kiểm soát tại cửa khởi hành."
    },
    {
      "value": "GPLX",
      "label": "Giấy phép lái xe"
    },
    {
      "value": "GTTT",
      "label": "Giấy tờ tuỳ thân"
    },
    {
      "value": "HDCX",
      "label": "Hướng dẫn chất xếp"
    },
    {
      "value": "HNH",
      "label": "Hàng nguy hiểm"
    },
    {
      "value": "HH-HL",
      "label": "Hàng hóa - hành lý"
    },
    {
      "value": "HLTL",
      "label": "Hành lý thất lạc"
    },
    {
      "value": "IGOM",
      "label": "Tài liệu Quốc tế hướng dẫn vận hành khai thác mặt đất"
    },
    {
      "value": "ISAGO",
      "label": "Tiêu chuẩn an toàn hàng không Quốc tế"
    },
    {
      "value": "KAD",
      "label": "Không áp dụng"
    },
    {
      "value": "Khách C",
      "label": "Khách hạng thương gia"
    },
    {
      "value": "KST",
      "label": "Kiểm soát tải"
    },
    {
      "value": "KTTB",
      "label": "Kỹ thuật tàu bay"
    },
    {
      "value": "LXĐK",
      "label": "Lái xe đầu kéo"
    },
    {
      "value": "MME",
      "label": "Maintenance Management Exposition: Tài liệu điều hành bảo dưỡng"
    },
    {
      "value": "NQLĐ",
      "label": "Nội qui lao động"
    },
    {
      "value": "NV",
      "label": "Nhân viên"
    },
    {
      "value": "PCCC",
      "label": "Phòng cháy chữa cháy"
    },
    {
      "value": "PTKB",
      "label": "Phương tiện khu bay"
    },
    {
      "value": "PVCB",
      "label": "Phục vụ chuyến bay"
    },
    {
      "value": "PVMĐ",
      "label": "Phục vụ mặt đất"
    },
    {
      "value": "PVHH",
      "label": "Phục vụ hàng hóa"
    },
    {
      "value": "PVHK",
      "label": "Phục vụ hành khách"
    },
    {
      "value": "PVHL",
      "label": "Phục vụ hành lý"
    },
    {
      "value": "PVSĐ",
      "label": "Phục vụ sân đỗ"
    },
    {
      "value": "PVTT",
      "label": "Phục vụ trên tàu"
    },
    {
      "value": "PXK",
      "label": "Phiếu xuất kho"
    },
    {
      "value": "SCL",
      "label": "Sửa chữa lớn"
    },
    {
      "value": "STB",
      "label": "Standby sổ chờ"
    },
    {
      "value": "TBĐH",
      "label": "Trực ban điều hành"
    },
    {
      "value": "TCKT",
      "label": "Tiêu chuẩn kỹ thuật khai thác"
    },
    {
      "value": "TKHLTL",
      "label": "Tìm kiếm hành lý thất lạc"
    },
    {
      "value": "TL",
      "label": "Tài liệu"
    },
    {
      "value": "TLHH",
      "label": "Tài liệu hàng hóa"
    },
    {
      "value": "TSBQ",
      "label": "Tài sản bỏ quên"
    },
    {
      "value": "TTB",
      "label": "Trang thiết bị phục vụ mặt đất"
    },
    {
      "value": "TTHH",
      "label": "Thủ tục hàng hóa"
    },
    {
      "value": "TTHL",
      "label": "Thủ tục hành lý"
    },
    {
      "value": "TTQT",
      "label": "Thanh toán quốc tế"
    },
    {
      "value": "Văn bản QPPL",
      "label": "Văn bản quy phạm pháp luật"
    },
    {
      "value": "VSTB",
      "label": "Vệ sinh tàu bay"
    },
    {
      "value": "VTVP",
      "label": "Vật tư vật phẩm"
    },
    {
      "value": "CBNV/ CB-CNV",
      "label": "Cán bộ công nhân viên"
    },
    {
      "value": "ATAN",
      "label": "An toàn an ninh"
    },
    {
      "value": "SSP",
      "label": "Chương trình an toàn quốc gia"
    },
    {
      "value": "VAR",
      "label": "Vietnam Aviation Regulations "
    },
    {
      "value": "SMSM",
      "label": "Tài liệu Hệ thống Quản lý an toàn của TCT Hàng không Việt Nam"
    },
    {
      "value": "V.QMS",
      "label": "Hệ thống quản lý chất lượng - Quality Management System "
    },
    {
      "value": "V.SMS",
      "label": "Hệ thống quản lý an toàn - Safety Management System "
    },
    {
      "value": "V.HRM",
      "label": "Quản lý nguồn nhân lực - Human Resources Management  "
    },
    {
      "value": "V.SPM",
      "label": "Quản lý nguồn vật lực- Support Processes Management "
    },
    {
      "value": "V.SOP",
      "label": "Quy trình khai thác - Standard Operating Procedure "
    },
    {
      "value": "V.IMM",
      "label": "Quy trình quản lý hệ thống Công nghệ thông tin- Information Technology Management Manual "
    },
    {
      "value": "V.MSM",
      "label": "Quy trình Tiếp thị và bán sản phẩm, dịch vụ - Marketing and Sales Management "
    },
    {
      "value": "V.TMM",
      "label": "Quy trình tổ chức đào tạo - Training Management Manual "
    },
    {
      "value": "V.TPM",
      "label": "Chương trình đào tạo - Training Program Manual "
    },
    {
      "value": "ANTT",
      "label": "An ninh thông tin"
    },
    {
      "value": "ATTT",
      "label": "An toàn thông tin"
    },
    {
      "value": "GSHT",
      "label": "Giám sát hành trình"
    },
    {
      "value": "SXKD",
      "label": "Sản xuất kinh doanh"
    },
    {
      "value": "BBBG",
      "label": "Biên bản bàn giao, nghiệm thu"
    },
    {
      "value": "TBM",
      "label": "Trưởng bộ môn"
    },
    {
      "value": "GVLT",
      "label": "Giáo viên lý thuyết"
    },
    {
      "value": "GVTH",
      "label": "Giáo viên thực hành"
    },
    {
      "value": "GVCNLT",
      "label": "Giáo viên chủ nhiệm lý thuyết"
    },
    {
      "value": "GVCNTH",
      "label": "Giáo viên chủ nhiệm thực hành"
    },
    {
      "value": "GVGSTH",
      "label": "Giáo viên giám sát thực hành "
    }
  ]